import { Link } from "react-router-dom";

/**
 * Hexagonal content card. Text sits in the widest band of the hex with a
 * dark gradient panel for legibility against any image.
 */
export default function HexCard({
  imageUrl,
  eyebrow,
  title,
  subtitle,
  to,
  href,
  onClick,
  testid,
}) {
  const inner = (
    <div className="hex-card group" data-testid={testid}>
      {/* image layer */}
      <div
        className="hex-inner"
        style={
          imageUrl
            ? {
                background: `url(${imageUrl}) center/cover no-repeat`,
                filter: "sepia(0.20) saturate(1.05) contrast(1.02)",
              }
            : undefined
        }
      />
      {/* legibility scrim — strongest in the band where text sits */}
      <div
        className="absolute inset-[2px] z-[2] pointer-events-none"
        style={{
          clipPath:
            "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)",
          background:
            "linear-gradient(180deg, rgba(44,26,12,0.05) 0%, rgba(44,26,12,0.25) 35%, rgba(44,26,12,0.78) 60%, rgba(44,26,12,0.92) 85%)",
        }}
      />
      {/* content — pinned to the widest band, not the bottom point */}
      <div className="absolute inset-0 z-[3] flex flex-col p-5 sm:p-6 pt-[14%]">
        <div className="flex justify-between items-start">
          {eyebrow ? (
            <span
              className="label-accent"
              style={{ color: "#f5d4a3", textShadow: "0 1px 2px rgba(0,0,0,0.4)" }}
            >
              {eyebrow}
            </span>
          ) : (
            <span />
          )}
          <span
            className="w-2 h-[9px] bg-[color:var(--nccc-ochre)]"
            style={{
              clipPath:
                "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)",
            }}
          />
        </div>

        <div className="mt-auto" style={{ paddingBottom: "22%" }}>
          <h3
            className="font-display text-base sm:text-lg leading-tight"
            style={{
              color: "#fff5e0",
              textShadow: "0 1px 3px rgba(0,0,0,0.5)",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {title}
          </h3>
          {subtitle && (
            <p
              className="mt-1 text-[10px] tracking-[0.15em] uppercase"
              style={{
                color: "#e8c89a",
                textShadow: "0 1px 2px rgba(0,0,0,0.5)",
                display: "-webkit-box",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );

  if (to) return <Link to={to} className="block">{inner}</Link>;
  if (href) return <a href={href} target="_blank" rel="noreferrer" className="block">{inner}</a>;
  if (onClick) return <button onClick={onClick} className="block w-full text-left">{inner}</button>;
  return inner;
}
